
































































import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { CampaignService } from '@/data/services/campaign.service';
import { Campaign, CampaignContact, CampaignOperator } from '@/data/models/campaign.model';
import { Search, SortDirection } from '@/data/models/search.model';
import CampagnaOperatoriSearch from './CampagnaOperatoriSearch.vue';

@Component
export default class CampagnaContattiList extends Vue {
	@Prop() campagna!: Campaign;
	@Prop() editable!: boolean;

	@Inject('CrudService') crudService!: CrudService<CampaignOperator>;
	@Inject('CampaignService') campaignService!: CampaignService;

	rows: CampaignOperator[] = [];
	loading: boolean = false;

	advancedSearch: Search = new Search('campaignoperator');

	constructor() {
		super();
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	created() {
		this.loadOperatori();
	}

	loadOperatori() {
		this.advancedSearch.addSimpleFilter('campaignid', this.campagna.id);

		const datareq = this.crudService.searchEntities(
			CampaignOperator,
			'campaignoperator',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			CampaignOperator,
			'campaignoperator',
			this.advancedSearch
		);
		this.loading = true;
		Promise.all([datareq, countreq])
			.then((results) => {
				this.rows = results[0];
				this.advancedSearch.page.setTotal(results[1].ct);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	addOperatori() {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: CampagnaOperatoriSearch,
			width: 960,
			hasModalCard: true,
			canCancel: false,
			events: {
				submit: (request: Search) => {
					this.campaignService
						.linkCampaignOperators(this.campagna.id, request)
						.then(() => {
							this.$buefy.notification.open({
								message: this.$t('success-save') as string,
								type: 'is-success',
							});
							this.loadOperatori();
							modal.close();
						})
						.catch(({ data }) => {
							this.$buefy.notification.open({
								message: data.msg || data.internal,
								type: 'is-danger',
							});
						});
				},
			},
		});
	}

	deleteOperatore(item: CampaignContact) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-campagna-operatore-delete') as string,
			type: 'is-danger',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				this.crudService.deleteEntity(CampaignOperator, 'campaignoperator', item).then(() => {
					this.$buefy.notification.open({
						message: this.$t('success-save') as string,
						type: 'is-success',
					});
					this.loadOperatori();
				}).catch(({ data }) => {
					this.$buefy.notification.open({
						message: data.msg || data.internal,
						type: 'is-danger',
					});
				});
			},
		});
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.loadOperatori();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.loadOperatori();
	}

}
